<template>
  <div>
    <template v-if="!['thailandpostmart'].includes(selectedBot.type)">
      <a href="https://blog.zwiz.ai/วิธีการลงสินค้าผ่านไฟล/" target="blank">
        <em style="font-size: 16px; color: #ff706b" class="fas fa-question-circle" />
      </a>

      <v-btn
        color="primary"
        :disabled="delayImport"
        :loading="loading"
        outline
        @click="onClickUploadButton"
      >
        <em class="fas fa-file-import" />
        &nbsp;
        {{ $t('import') }}
      </v-btn>
      <input
        :id="'cdsCsvUpload'"
        v-validate="'mimes:text/xlsx'"
        type="file"
        class="form-control-file pt-2"
        name="cdsCsvUpload"
        data-vv-as="File"
        accept=".xlsx"
        style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
        @input="onFileChange($event)"
      />
    </template>
  </div>
</template>

<script>
import customizeShopApi from '@/api/customize-shop'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import { handleApiError } from '@/api/util'

export default {
  data() {
    return {
      delayImport: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    toggleLoading() {
      this.$store.state.loading = !this.$store.state.loading
    },
    onClickUploadButton() {
      document.getElementById('cdsCsvUpload').click()
    },

    onFileChange(event) {
      const vm = this

      let files = event.target.files || event.dataTransfer.files
      let myFile = files[0]
      let reader = new FileReader()

      reader.onloadstart = async () => {
        vm.loading = true
        vm.$store.state.loading = true
      }

      reader.onload = async (e) => {
        let data = new Uint8Array(e.target.result)

        const workbook = XLSX.read(data)
        const sheetName = workbook.SheetNames[1]

        const sheet = workbook.Sheets[sheetName]
        const result = XLSX.utils.sheet_to_json(sheet)

        vm.uploadProductCustomize(result)
      }

      reader.onloadend = () => {
        vm.$store.state.loading = false
        vm.loading = false
      }

      reader.onerror = (error) => {
        console.log('error: ', error)
        vm.$store.state.loading = false
      }

      reader.readAsArrayBuffer(myFile)
    },
    async trimObj(obj) {
      const vm = this
      try {
        if (!Array.isArray(obj) && typeof obj != 'object') {
          return obj
        }

        return Object.keys(obj).reduce(
          function (acc, key) {
            acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
            return acc
          },
          Array.isArray(obj) ? [] : {}
        )
      } catch (error) {
        console.error(error)
      }
    },

    async uploadProductCustomize(file) {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          body: {
            products: file
          }
        }

        const response = await customizeShopApi.postImportProductCustomize({ data })

        if (response && response.status === 204) {
          vm.$swal
            .fire({
              type: 'success',
              text: 'นำเข้าสินค้าสำเร็จ'
            })
            .then((result) => {
              if (result.value) {
                vm.$emit('success')
              }
            })

          vm.loading = false
        } else {
          vm.$swal.fire({
            text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
          })

          vm.loading = false
        }
      } catch (error) {
        vm.loading = false
        console.error(error)
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ImportShopCds.vue